<template>
    
    <transition-group name="scroll-x-transition">

        <v-select
            :items="productTypes"
            item-text="name"
            v-model="selectedItems.productType"
            label="Product type"
            dense return-object
            color="white"
            prepend-icon="mdi-camera"
            :menu-props="{ offsetY: true }"
            key="product-type">
        </v-select>


        <v-select 
            v-if="showCountries"
            :items="countries"
            item-text="name"
            v-model="selectedItems.country"
            label="Country"
            dense return-object
            color="white"
            prepend-icon="mdi-earth"
            key="country">
        </v-select>

        <v-autocomplete 
            v-if="showAois"
            :items="aois"
            item-text="name"
            v-model="selectedItems.aoi"
            label="Area"
            dense return-object
            color="white"
            prepend-icon="mdi-vector-square"
            key="aoi">
        </v-autocomplete>

        <div v-if="showOperation" key="operations">

            <v-select 
                :items="operations"
                v-model="selectedItems.operation"
                label="operation"
                color="white"
                dense
                prepend-icon="mdi-calculator-variant"
                key="operation">
            </v-select>

            <date-picker-component
                :label="calanderOptions.label1"
                v-model="selectedItems.date1"
                :allowed-dates="calanderOptions.allowedDates"
                :type="calanderOptions.type"
                icon="mdi-calendar-today"
                key="date1"
                @change="dateChanged"
            ></date-picker-component>
            
            <v-scroll-x-transition>
                <div v-if="calanderOptions.showDate2">
                    <date-picker-component
                        :label="calanderOptions.label2"
                        v-model="selectedItems.date2"
                        :allowed-dates="calanderOptions.allowedDates"
                        :type="calanderOptions.type"
                        key="date2"
                    ></date-picker-component>

                </div>
            </v-scroll-x-transition>

        </div>

    </transition-group>

</template>

<script>

import ApiClient from "../classes/ApiClient";
import MainMap from '../classes/MainMap';

export default {

    props: {
        apiClient : {
            type: ApiClient,
            required: true,
        },

        mainMap : {
            type: MainMap,
            required : true,
        },

        productTypes : {
            type: Array,
            required : true,
        },

        selectedItems : {
            type : Object,
            default : {
                productType : null,
                country : null,
                aoi : null,
                operation : 'view',
                date1 : null,
                date2: null
            }
        }

    },

    data: function() {

        return {

            countries: [],
            aois: [],
            operations: [
                'view',
                'change',
                'summarize'
                ],
            products: [],

            downloadLink: '',
            dtype : '',

        };
    },


    mounted() {

         // add another select handler so that selected AOI's are in sync
        this.mainMap.select.on('select', (e) => {
            this.selectedItems.aoi = this.mainMap.selectedAoi;
        })

    },

    methods: {

        dateChanged()
        {
            this.mainMap.setSentinelDate(this.selectedItems.date1);
        }
    },

    computed: {

        showCountries: function () {
            return this.selectedItems.productType && this.countries.length > 0;
        },

        showAois : function() {
            return this.selectedItems.country && this.aois.length > 0;
        },

        showOperation : function() {
            return this.selectedItems.aoi;
        },

        calanderOptions: function() {
            
            let options = {
                type : 'date',
                allowedDates: [],
                label1 : 'date',
                label2 : 'date',
                showDate2 : false,
                minDate : null,
            }

            if(this.selectedItems.productType.product_type_period_id == 1) // daily
            {
                options.allowedDates = this.products.map(product => product.date).sort();
            }

            if(this.selectedItems.productType.product_type_period_id == 2) // monthly
            {
                options.type = 'month';
                options.allowedDates = this.products.map(product => product.date.substring(0, 7)).sort();
            }

            if(this.selectedItems.operation != 'view') // if not view operation
            {
                options.label1 = 'from';
                options.label2 = 'to';
                options.showDate2 = true;
            }

            return options
        }
    },

    watch: {

        'selectedItems.productType': function (val) {


            this.selectedItems.country = null;
            this.countries = [];
            
            if(val == null)
                return;
                
            this.apiClient.productTypeCountries(val.id, true)
                .then(response => {
                    this.countries = response.data;
                })

        },

        'selectedItems.country': function (val) {

            this.selectedItems.aoi = null;
            this.aois = [];
            this.mainMap.setAois(this.aois);

            if(val == null)
                return;

            this.apiClient.productTypeCountryAois(this.selectedItems.productType.id, val.id, true)
                .then(response => {
                    this.aois = response.data;
                    this.mainMap.setAois(this.aois);
                })

        },


        'selectedItems.aoi': function (val) {

            this.selectedItems.date1 = null;
            this.selectedItems.date2 = null;

            if(val == null)
            {
                this.mainMap.deselectAois();
                return;
            }

            this.mainMap.selectAoi(val);

            this.apiClient.productTypeAoiProducts(this.selectedItems.productType.id, val.id)
                .then(response => {
                    this.products = response.data;
                })
        },

    }

}

</script>
